import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useDashboardService = () => {
  const { api } = useApiClient();

  const fetchDashboardDetails = useCallback(
    async (data) => {
      try {

        const response = await api.post("/api/dashboard/fetch", data);
        return await response.data;
      } catch (error) {
        return null;
      }
    },
    [api]
  );
  const saveDashboardDetails = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/dashboard/save", data);
        return await response.data;
      } catch (error) {
        return null;
      }
    },
    [api]
  );
  return { fetchDashboardDetails, saveDashboardDetails };
};
